import { createSelector } from '@ngrx/store';
import { CardStatus, VehicleType } from 'src/graphql/generated/graphql.generated';
import { selectAllCardSummaryEntities } from 'src/store/generated/card-summary-record.generated';
import { selectUnitSummariesByCurrentCompany } from './unit-selectors';

export function selectCardSummaryEntityByRequestId(requestId: string) {
  return createSelector(selectAllCardSummaryEntities, (entities) => {
    const cardSummary = entities.find((e) => e.request != null && e.request.id === requestId);
    return cardSummary;
  });
}

export function selectCardSummaryEntityByCardNumber(cardNumber: string) {
  return createSelector(selectAllCardSummaryEntities, (entities) =>
    entities.find((e) => e.cardNumber === cardNumber),
  );
}

export function selectCardSummaryEntitiesByCurrentCompany(
  currentCompanyId: string,
  excludeDispatchByCurrentCompany: boolean,
  unitNameOrTailLike?: string,
  vehicleTypes: VehicleType[] = [],
  companyIds: string[] = [],
  ...status: CardStatus[]
) {
  return createSelector(
    selectAllCardSummaryEntities,
    selectUnitSummariesByCurrentCompany(
      currentCompanyId,
      excludeDispatchByCurrentCompany,
      unitNameOrTailLike,
      companyIds,
      vehicleTypes,
    ),
    (cards, units) => {
      return cards
        .filter(
          (card) =>
            units.some((unit) => unit.id === card.unitId) &&
            (status.length === 0 || status.includes(card.status)),
        )
        .toOrderedSet()
        .sort((a, b) => (a.dateCreated < b.dateCreated ? -1 : 1));
    },
  );
}
